"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { authService } from '@/services/auth.service';
import Navbar from '@/components/landing/Navbar';
import Hero from '@/components/landing/Hero';
import TrustedBrands from '@/components/landing/TrustedBrands';
import Features from '@/components/landing/Features';
import Courses from '@/components/landing/Courses';
import HowItWorks from '@/components/landing/HowItWorks';
import ForCompanies from '@/components/landing/ForCompanies';
import Testimonials from '@/components/landing/Testimonials';
import AboutUs from '@/components/landing/AboutUs';
import CTA from '@/components/landing/CTA';
import Footer from '@/components/landing/Footer';
export default function Home() {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== router) {
    t0 = () => {
      if (authService.isAuthenticated()) {
        const role = authService.getUserRole();
        if (role) {
          switch (role.toLowerCase()) {
            case "student":
              {
                router.push("/student/dashboard");
                return;
              }
            case "company":
              {
                router.push("/company/dashboard");
                return;
              }
            case "teacher":
              {
                router.push("/teacher/dashboard");
                return;
              }
            case "admin":
              {
                router.push("/admin/dashboard");
                return;
              }
          }
        }
      }
    };
    t1 = [router];
    $[0] = router;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="min-h-screen"><Navbar /><Hero /><TrustedBrands /><Features /><Courses /><HowItWorks /><ForCompanies /><Testimonials /><AboutUs /><CTA /><Footer /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}